import { render, staticRenderFns } from "./MpMaterialList.vue?vue&type=template&id=0e618992&"
import script from "./MpMaterialList.vue?vue&type=script&lang=js&"
export * from "./MpMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./MpMaterialList.vue?vue&type=style&index=0&id=0e618992&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports